/**
 * Get the corresponding color for a given mode or node type
 */

import {
  AIRPORT,
  MAP_LINE_COLOR_AIR,
  MAP_LINE_COLOR_RAIL,
  MAP_LINE_COLOR_ROAD,
  MAP_LINE_COLOR_WATER,
  MODE_AIR,
  MODE_RAIL,
  MODE_ROAD,
  MODE_TRANSFER,
  MODE_WATER,
  SEAPORT,
} from '@/lib/constants';
import { colors } from '@/theme/constants';

type TransportColorInterface =
  | typeof MODE_AIR
  | typeof MODE_WATER
  | typeof MODE_ROAD
  | typeof MODE_RAIL
  | typeof MODE_TRANSFER
  | typeof AIRPORT
  | typeof SEAPORT
  | string;

const getTransportColor = (transportMode: TransportColorInterface, highContrast = false): string => {
  if (transportMode === MODE_AIR || transportMode === AIRPORT) {
    return !highContrast ? colors.transport.plane : MAP_LINE_COLOR_AIR;
  }

  if (transportMode === MODE_WATER || transportMode === SEAPORT) {
    return !highContrast ? colors.transport.ship : MAP_LINE_COLOR_WATER;
  }

  if (transportMode === MODE_ROAD) {
    return !highContrast ? colors.transport.road : MAP_LINE_COLOR_ROAD;
  }

  if (transportMode === MODE_RAIL) {
    return !highContrast ? colors.transport.rail : MAP_LINE_COLOR_RAIL;
  }

  if (transportMode === MODE_TRANSFER) {
    return colors.transport.transfer;
  }

  return '';
};

const getTransportTextColor = (transportMode: TransportColorInterface): string => {
  if (transportMode === MODE_AIR || transportMode === AIRPORT) {
    return colors.white;
  }

  if (transportMode === MODE_WATER || transportMode === SEAPORT) {
    return colors.white;
  }

  if (transportMode === MODE_ROAD) {
    return colors.text.primary;
  }

  if (transportMode === MODE_RAIL) {
    return colors.text.primary;
  }

  if (transportMode === MODE_TRANSFER) {
    return colors.text.primary;
  }

  return '';
};

export { getTransportColor, getTransportTextColor };
